import { useState } from "react";
import { motion } from "motion/react";
import ChevronDown from "assets/svg/chevron-down";

/**
 * @param {CollapsibleProps} param0
 */
export default function Collapsible({
  title,
  content,
  hidden = false,
  hideButton = false,
  openDefault = true,
  showButtonBelow = false,
  footerTitle
}) {
  const [open, setOpen] = useState(openDefault);

  const toggle = () => {
    setOpen((s) => !s);
  };

  if (hidden) return null;

  return (
    <div>
      <motion.div
        className="flex flex-row items-center gap-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        {!hideButton && (
          <div>
            <CollapsibleToggleButton toggle={toggle} open={open}/>
          </div>
        )}
        <div>{title({ toggle, open })}</div> 
      </motion.div>
      <motion.div
        initial={{ height: open ? "auto" : 0, opacity: 1 }}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        // className="overflow-hidden"
      >
        {content({ toggle, open })}
      </motion.div>
      {
        showButtonBelow && 
        <motion.div
          className="flex flex-row items-center gap-4 mt-4 justify-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {open && (
            <> 
              <div>
                <CollapsibleToggleButton toggle={toggle} open={open}/>
              </div>
              <div className="organize-title px-0 text-lightBlack font-bold text-lg leading-7.5 tracking-tighter">
                {footerTitle}
              </div> 
              
            </>
          )}
          
        </motion.div>
      }
    </div>
  );
}

export function CollapsibleToggleButton({ toggle, open }) {
  return (
    <button
      onClick={toggle}
      className="w-[1.75rem] h-[1.75rem] bg-neutral-200 text-[#333333]
                                    flex items-center justify-center rounded-full transition-all
                                    duration-300"
      style={{ transform: open ? "rotateZ(180deg)" : "rotateZ(0deg)" }}
    >
      <ChevronDown />
    </button>
  );
}
